<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Container Test Type', apiMethod: 'ContainerTestTypes', form: () => import('../forms/ContainerTestTypeForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Container Test', apiMethod: 'ContainerTests', parentForeignKey: 'containerTestTypeId', form: () => import('../forms/ContainerTestForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Container Tests', value: 'containerTestTypeId', isCard: true, table: () => import('../tables/ContainerTestsTable') },
                ],
                mainForm: () => import('../forms/ContainerTestTypeForm'),
                claimName: 'ContainerTestTypes',
                apiMethod: 'ContainerTestTypes',
            }
        }
    };
</script>
